import {
  ApiUpdateProductQuantityFromMyWishlistFailedAction,
  ApiUpdateProductQuantityFromMyWishlistSucceededAction,
  apiUpdateProductQuantityFromMyWishlistFailedType,
  apiUpdateProductQuantityFromMyWishlistRequested,
  apiUpdateProductQuantityFromMyWishlistSucceededType
} from '@spa/lib/store/api/wishlists/updateProductQuantityFromMyWishlistApi';
import {
  UpdateProductQuantityFromMyWishlistRequestedAction,
  updateProductQuantityFromMyWishlistFailed,
  updateProductQuantityFromMyWishlistSucceeded
} from '@spa/lib/store/wishlists/wishlistsSlice';
import generateActionId from '@spa/lib/generateActionId';
import { put } from 'typed-redux-saga';
import waitForSucceededOrFailedAction from '@spa/lib/store/sagas/session/waitForSucceededOrFailedAction';

function* updateProductQuantityFromMyWishlistSaga({
  payload: { actionId: requestedActionId, input }
}: UpdateProductQuantityFromMyWishlistRequestedAction): Generator {
  const actionId: number = generateActionId();

  yield* put(
    apiUpdateProductQuantityFromMyWishlistRequested({
      actionId,
      input,
      parentActionId: requestedActionId
    })
  );

  const waitResult = yield* waitForSucceededOrFailedAction<
    typeof apiUpdateProductQuantityFromMyWishlistSucceededType,
    typeof apiUpdateProductQuantityFromMyWishlistFailedType,
    ApiUpdateProductQuantityFromMyWishlistSucceededAction,
    ApiUpdateProductQuantityFromMyWishlistFailedAction
  >(
    actionId,
    apiUpdateProductQuantityFromMyWishlistSucceededType,
    apiUpdateProductQuantityFromMyWishlistFailedType
  );

  if (waitResult.type === 'succeeded') {
    yield* put(
      updateProductQuantityFromMyWishlistSucceeded({
        input: waitResult.action.payload.input,
        requestedActionId
      })
    );
  } else {
    yield* put(
      updateProductQuantityFromMyWishlistFailed({
        error: waitResult.action.payload.error,
        requestedActionId
      })
    );
  }
}

export default updateProductQuantityFromMyWishlistSaga;
